// extracted by mini-css-extract-plugin
export default {"strip":"Ed3WtH","root":"SO7ITY"};